export enum AdyenUrlSourceSettings {
  TERMINAL = 'terminals',
  MERCHANT = 'merchants',
}
